import React from 'react'
import PropTypes from 'prop-types'
import { Table, TableColumn } from 'lp-components'
import { formatCurrency } from 'utils'

function ParticipantsSummaryTable({ data, title }) {
  return (
    <div className="participant-summary-table">
      <div className="form-header">{title}</div>
      <Table data={data}>
        <TableColumn name="planName" label="Complete legal plan name" />
        <TableColumn name="participants" label="Number of participants" />
        <TableColumn
          name="taxableAmount"
          label="Taxable amount"
          format={formatCurrency}
        />
      </Table>
    </div>
  )
}

ParticipantsSummaryTable.propTypes = {
  data: PropTypes.arrayOf(PropTypes.object).isRequired,
  title: PropTypes.node.isRequired,
}
ParticipantsSummaryTable.defaultProps = {}

export default React.memo(ParticipantsSummaryTable)
